export const inr = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const win = (n) =>
  `${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 4 })} WIN`;

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  return isNaN(d)
    ? String(s)
    : d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};
